"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchTranslations = fetchTranslations;
var _axios = require("@ori/axios");
var _fetching = require("@ori/fetching");
var _md = _interopRequireDefault(require("crypto-js/md5"));
var _constants = require("../../internals/constants");
var axiosInstance;
function assertHeaders(headers) {
    return headers != null && (typeof headers === "undefined" ? "undefined" : _type_of(headers)) === 'object';
}
function getAxios() {
    if (!axiosInstance) {
        axiosInstance = (0, _axios.createAxiosWithCache)({
            key: function(param) {
                var headers = param.headers, url = param.url, params = param.params;
                var defaultKey = (0, _md.default)("".concat(url, "_").concat(JSON.stringify(params !== null && params !== void 0 ? params : {}))).toString();
                if (assertHeaders(headers) && _fetching.ACCEPT_LANGUAGE in headers) {
                    return "".concat(headers[_fetching.ACCEPT_LANGUAGE], "_").concat(defaultKey);
                }
                return defaultKey;
            },
            maxAge: _constants.TRANSLATIONS_CACHE_MAX_AGE
        });
    }
    return axiosInstance;
}
function fetchTranslations(_) {
    return _fetchTranslations.apply(this, arguments);
}
function _fetchTranslations() {
    _fetchTranslations = /**
 * @deprecated Use [fetchTranslationsWithNamespaces](../../utils/fetchTranslationsWithNamespaces.ts) which accepts TranslationsKeysWithNamespaces to support POEditor localizations only.
 * */ _async_to_generator(function(param) {
        var baseUrl, currentLanguage, keys, onError, url, entries, _ref, translations, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    baseUrl = param.baseUrl, currentLanguage = param.currentLanguage, keys = param.keys, onError = param.onError;
                    url = new _axios.SafeURL(_constants.TRANSLATIONS_ENDPOINT, baseUrl);
                    entries = Object.values(keys);
                    entries.forEach(function(value) {
                        return url.searchParams.append(_constants.TRANSLATIONS_QUERY_PARAMETER_NAME, value);
                    });
                    if (currentLanguage) {
                        url.searchParams.append('sc_lang', currentLanguage);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getAxios().get(url.toString(), currentLanguage ? {
                            headers: _define_property({}, _fetching.ACCEPT_LANGUAGE, currentLanguage)
                        } : undefined)
                    ];
                case 2:
                    _ref = _state.sent(), translations = _ref.data;
                    return [
                        2,
                        {
                            // Now just swap keys from API with actual keys defined in keys
                            translations: translations
                        }
                    ];
                case 3:
                    error = _state.sent();
                    if (_axios.axios.isAxiosError(error)) {
                        onError === null || onError === void 0 ? void 0 : onError(error);
                        // Returns defaults when error occurs
                        return [
                            2,
                            {
                                error: error,
                                translations: keys
                            }
                        ];
                    }
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    } //# sourceMappingURL=fetchTranslations.js.map
    );
    return _fetchTranslations.apply(this, arguments);
}
